import styled from '@emotion/styled';
import { LogoDebitCard } from 'src/domains/common/paymentMethods/paymentOptions/LogoDebitCard';
import { withConfig } from 'src/withConfig';


export const LogoDebitCardWrapper = withConfig(theme => styled(LogoDebitCard, { label: 'LogoDebitCardWrapper' })`
    fill: ${theme.star.multiDeposit.bgColorSecondary};
`);
